<script>
    import "../project-card/projectCard.css";
    import {formatUnits} from "ethers/lib/utils";
    import {getProjectMetaService} from "../../../services/api";
    import {ABSOLUTE_ZERO_REGEX, BASE_URL, PROJECT_STATUSES, COMPLETE_TIME_FORMAT} from "../../constants/constants";
    import { projectDetail } from "../../store";
    import {link} from 'svelte-spa-router'
    import {
        formatNumberComma,
        getAfterTimestampDate,
        getAfterTimeStampStrapi,
        getRelativeTime,
        getTime,
        getTokenPrice,
        sliceOffDecimalNumbers
    } from "../../utils";
    import ProgressBar from "../progressbar/ProgressBar.svelte";


    export let project
    let projectMeta, liveProjectTimeRemaining,liveStrapiProjectTimeRemaining,projectTier = ""

    $: saleCardDetails = {
        raiseTarget: "",
        totalSupply: "",
        startTime: "",
        endTime: "",
        unitsAvailable: "",
        totalRaised: "",
        price: ""
    }

    const setProjectTier = async () =>
        projectTier = project && project.wallet_tier.data && project.wallet_tier.data.attributes.tier_label;

    $: if(projectMeta && projectMeta.canEndStateConfig &&
        PROJECT_STATUSES.LIVE === project.project_status &&
        projectMeta.startEvent) {
        setInterval(() => {
            const {timeRemaining} = getTime(projectMeta);
            liveProjectTimeRemaining = timeRemaining
        }, 1000);
        
    }

    $:if(project.project_status===PROJECT_STATUSES.LIVE&& !project.sale_address){
        setInterval(() => {
            const {timeRemaining} = getTime(false,project.project_end_time,project.project_start_time);
            liveStrapiProjectTimeRemaining = timeRemaining
        }, 1000);
    }
    $:liveStrapiTimeChecker = liveStrapiProjectTimeRemaining
    const setProjectData = async () => {
        const { data } = await getProjectMetaService(project.sale_address);
        projectMeta = data.sales[0];
        setSaleData(data.sales[0]);
    }

    const setSaleData = (sale) => {
        saleCardDetails = {
            raiseTarget: Number(formatUnits(sale.minimumRaise, sale.reserve.decimals)),
            totalSupply: Number(+formatUnits(sale.token.totalSupply, sale.token.decimals)),
            startTime: sale.canStartStateConfig,
            endTime: sale.canEndStateConfig,
            unitsAvailable: Number((+formatUnits(sale.unitsAvailable, sale.token.decimals))),
            totalRaised: Number((+formatUnits(sale.totalRaised, sale.reserve.decimals))),
            price: getTokenPrice(sale),
            tokenName: sale.token.name,
            tokenSymbol: sale.token.symbol,
            percentRaised: sale.percentRaised
        }
    }
    if(project.sale_address) {
        setProjectData();
    }
        setProjectTier();

    $: console.log(saleCardDetails.raiseTarget,"saleCardDetails.raiseTarget")
</script>
<div class="slider-wrapper flex">
    <a class="flex column-direction" on:click={()=> {projectDetail.set(project)}} href={`/project-details/${project.id}/${project.sale_address ? project.sale_address : ""}`} use:link>
    <div class="card column-direction">
        <div class="card-body">
            <figure>
                <img src={`${BASE_URL+project.project_cover.data.attributes.formats.thumbnail.url}`} alt="cardImage">
                <span class="tier">{projectTier ? projectTier : ""}</span>
                <span class={`status ${project.project_status.toLowerCase()}`}>{project.project_status === PROJECT_STATUSES.LIVE ? "Ongoing" : project.project_status}</span>
            </figure>
            <section class="text-left">
                <h2>{project.project_name}</h2>
                <p>{project.project_description}</p>
                <ul class="list-none flex column-direction">
                    <li class="flex">
                        <strong>Raise Target</strong>
                        <span class="ml-auto">${project.sale_address? sliceOffDecimalNumbers(saleCardDetails.raiseTarget) : sliceOffDecimalNumbers(project.project_raise_target)}</span>
                    </li>
                    <li class="flex">
                        <strong>Token Price</strong>
                        <span class="ml-auto">${project.sale_address ?sliceOffDecimalNumbers(saleCardDetails.price) : sliceOffDecimalNumbers(project.project_token_price) }</span>
                    </li>
                    {#if PROJECT_STATUSES.LIVE === project.project_status && saleCardDetails.endTime }
                        <li class="flex">
                            <strong>Time Remaining</strong>
                            <span class="ml-auto">{(liveProjectTimeRemaining ? liveProjectTimeRemaining : getRelativeTime(saleCardDetails.endTime))}</span>
                        </li>
                    {/if}
                        
                    {#if PROJECT_STATUSES.LIVE === project.project_status && !project.sale_address}
                    <li class="flex">
                        <strong>Time Remaining</strong>
                        <span class="ml-auto">{(liveStrapiTimeChecker)}</span>
                    </li>
                    {/if}
                    {#if PROJECT_STATUSES.UPCOMING === project.project_status}
                        <li class="flex">
                            <strong>Start Time</strong>
                            <span class="ml-auto">{getAfterTimeStampStrapi(project.project_start_time, COMPLETE_TIME_FORMAT)}</span>
                        </li>
                        <li class="flex">
                            <strong>End Time</strong>
                            <span class="ml-auto">{getAfterTimeStampStrapi(project.project_end_time, COMPLETE_TIME_FORMAT)}</span>
                        </li>
                    {/if}
                    {#if PROJECT_STATUSES.COMPLETED === project.project_status}
                        <li class="flex">
                            <strong>Date Ending</strong>
                            <span class="ml-auto">{saleCardDetails.endTime?getAfterTimestampDate(saleCardDetails.endTime, COMPLETE_TIME_FORMAT):getAfterTimeStampStrapi(project.project_end_time,COMPLETE_TIME_FORMAT)}</span>
                        </li>
                    {/if}
                    {#if PROJECT_STATUSES.UPCOMING !== project.project_status}
                    <li>
                        <ProgressBar {saleCardDetails} {project}/>
                    </li>
                    {/if}
                </ul>
            </section>
        </div>
    </div>
    </a>
</div>
